import { MACHINE_DEFS } from '@sim/content/machine-defs';
import { CREATION_KINDS } from '@sim/content/creation-kinds';
import type { CreationKind } from '@sim/content/creation-kinds';
import type { MachineKind } from '@sim/core/entities';

/**
 * Single source of truth for which machine/observable kinds need a tile — `game-textures.ts`'s
 * full-resolution bakes and `pixi-app.ts`'s toolbar thumbnail extraction both iterate these
 * instead of each hand-listing the same kinds, so a new machine or observable kind only needs adding
 * to `MACHINE_DEFS`/`CREATION_KINDS` to get a tile everywhere.
 */
export const TILE_MACHINE_KINDS = Object.keys(MACHINE_DEFS) as MachineKind[];
export const TILE_CREATION_KINDS = Object.keys(CREATION_KINDS) as CreationKind[];
